// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";
import merge from "lodash/merge";

export interface XCheckoutDeliveryInfo {
    shippingInstructions?: string;
    pickupInstructions?: string;
    carrierAccountNumber?: string;
    isUpdatingShippingMethod?: boolean;
}

export interface XCheckoutStateType {
    deliveryInfo: XCheckoutDeliveryInfo;
    releaseNumber?: string;
    isPlaceOrderDisabled?: boolean;
    isAddressInvalid?: boolean;
    isEditingBillTo?: boolean;
    isEditingShipTo?: boolean;
    notes?: string;
}

export const initialXCheckoutState: XCheckoutStateType = {
    deliveryInfo: {},
    releaseNumber: "",
    isPlaceOrderDisabled: false,
    isAddressInvalid: false,
    isEditingBillTo: false,
    isEditingShipTo: false,
    notes: "",
};

const reducer = {
    "xCheckout/Update": (draft: Draft<XCheckoutStateType>, action: { data: Partial<XCheckoutStateType> }) => {
        if (action.data) {
            Object.assign(draft, merge({}, draft, action.data));
        }
    },
    "xCheckout/Reset": (draft: Draft<XCheckoutStateType>) => {
        draft.deliveryInfo = {};
        draft.releaseNumber = "";
        draft.isPlaceOrderDisabled = false;
        draft.isAddressInvalid = false;
        draft.isEditingBillTo = false;
        draft.isEditingShipTo = false;
        draft.notes = "";
    },
};

const xCheckout = createTypedReducerWithImmer(initialXCheckoutState, reducer);

(reducers as any).xCheckout = xCheckout;

export type xCheckoutState = {
    xCheckout: XCheckoutStateType;
} & ApplicationState;

type xCheckoutReducers = {
    [key: string]: typeof xCheckout;
};

export type xCheckoutActions = Parameters<xCheckoutReducers[keyof xCheckoutReducers]>[1] | AnyAction;
